/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbMobileAppliedFilters_user = {
    readonly " $fragmentRefs": FragmentRefs<"useMeasurementUnit_user">;
    readonly " $refType": "SbMobileAppliedFilters_user";
};
export type SbMobileAppliedFilters_user$data = SbMobileAppliedFilters_user;
export type SbMobileAppliedFilters_user$key = {
    readonly " $data"?: SbMobileAppliedFilters_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbMobileAppliedFilters_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbMobileAppliedFilters_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "measurementUnit",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '31f18f132cb7542a629b702cb97027ee';
export default node;
